export default class GetSeguimientosResultadoC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado) {
    return await this.#repository.getAll(idPersonal, idResultado)
  }
}
